/**
 * Note all events fired include the searchSessionId, experiment-id, queryHash, queryVersion, wordCount, resultCount where applicable
 */

export const DEFAULT_GAS_CHANNEL = 'fabric-elements';
export let Trigger = /*#__PURE__*/function (Trigger) {
  Trigger["SHORTCUT"] = "shortcut";
  Trigger["SHORTCUT_MODIFIED"] = "shortcutModified";
  Trigger["RETURN"] = "return";
  Trigger["CLICK"] = "click";
  Trigger["TEXT_ENTERED"] = "textEntered";
  return Trigger;
}({});
export let AdvancedSearchLinkSubjectId = /*#__PURE__*/function (AdvancedSearchLinkSubjectId) {
  AdvancedSearchLinkSubjectId["CONFLUENCE"] = "confluenceAdvancedSearchLink";
  AdvancedSearchLinkSubjectId["CONFLUENCE_PEOPLE"] = "confluencePeopleSearchLink";
  AdvancedSearchLinkSubjectId["JIRA_ISSUES"] = "jiraIssuesSearchLink";
  AdvancedSearchLinkSubjectId["JIRA_BOARDS"] = "jiraBoardsSearchLink";
  AdvancedSearchLinkSubjectId["JIRA_FILTERS"] = "jiraFiltersSearchLink";
  AdvancedSearchLinkSubjectId["JIRA_PROJECTS"] = "jiraProjectsSearchLink";
  AdvancedSearchLinkSubjectId["JIRA_PLANS"] = "jiraPlansSearchLink";
  AdvancedSearchLinkSubjectId["JIRA_PEOPLE"] = "jiraPeopleSearchLink";
  AdvancedSearchLinkSubjectId["NO_RESULTS"] = "noResultsAdvancedSearchLink";
  return AdvancedSearchLinkSubjectId;
}({});
const BASE_ANALYTICS_SOURCE = 'searchDialog';

/**
 * Custom GasPayload type with restrictions so we don't include common attributes that will be added as part of AnalyticContexts
 */

export const onAdvancedSearchSelected = ({
  trigger,
  actionSubjectId,
  isLoading,
  newTab
}) => {
  return {
    action: 'selected',
    actionSubject: 'advancedSearchLink',
    actionSubjectId,
    source: BASE_ANALYTICS_SOURCE,
    eventType: 'track',
    attributes: {
      trigger,
      isLoading,
      newTab
    }
  };
};
export const onAskAtlassianIntelligenceSelected = ({
  trigger,
  actionSubjectId,
  isLoading,
  newTab
}) => {
  return {
    action: 'selected',
    actionSubject: 'askAtlassianIntelligenceLink',
    actionSubjectId,
    source: BASE_ANALYTICS_SOURCE,
    eventType: 'track',
    attributes: {
      trigger,
      isLoading,
      newTab
    }
  };
};
export const onXButtonClicked = ({
  actionSubjectId,
  searchSessionId
}) => {
  return {
    action: 'dismissed',
    actionSubject: 'stickySearch',
    actionSubjectId,
    source: BASE_ANALYTICS_SOURCE,
    eventType: 'ui',
    attributes: {
      searchSessionId
    }
  };
};
export const onNonDebouncedSearchTriggered = () => {
  return {
    action: 'triggered',
    actionSubject: 'nonDebouncedSearch',
    source: BASE_ANALYTICS_SOURCE,
    eventType: 'ui'
  };
};
export const onStickySearchCleared = ({
  timeout
}) => {
  return {
    eventType: 'track',
    action: 'cleared',
    actionSubject: 'stickySearch',
    source: BASE_ANALYTICS_SOURCE,
    attributes: {
      timeout
    }
  };
};
export const onAutocorrectShown = ({
  source,
  attributes
}) => {
  return {
    eventType: 'ui',
    action: 'shown',
    actionSubject: 'link',
    actionSubjectId: 'autocorrect',
    source: source,
    attributes: attributes
  };
};
export const onAutocorrectClicked = ({
  source,
  attributes
}) => {
  return {
    eventType: 'ui',
    action: 'clicked',
    actionSubject: 'link',
    actionSubjectId: 'autocorrect',
    source: source,
    attributes: attributes
  };
};
export const onHoverPreviewShow = ({
  actionSubjectId
}) => ({
  eventType: 'ui',
  source: BASE_ANALYTICS_SOURCE,
  action: 'show',
  actionSubject: 'hoverPreview',
  actionSubjectId
});
export const onHoverPreviewShown = ({
  actionSubjectId
}) => ({
  eventType: 'ui',
  source: BASE_ANALYTICS_SOURCE,
  action: 'shown',
  actionSubject: 'hoverPreview',
  actionSubjectId
});
export const onHoverPreviewClicked = ({
  actionSubjectId
}) => ({
  eventType: 'ui',
  source: BASE_ANALYTICS_SOURCE,
  action: 'clicked',
  actionSubject: 'hoverPreview',
  actionSubjectId
});
export const onCardRequestFailed = ({
  attributes
}) => ({
  eventType: 'operational',
  source: BASE_ANALYTICS_SOURCE,
  action: 'failed',
  actionSubject: 'trelloCardRequest',
  attributes: {
    ...attributes
  }
});
export const onSearchResultViewAllLinkClicked = sectionId => ({
  eventType: 'ui',
  action: 'clicked',
  actionSubject: 'link',
  actionSubjectId: 'searchResultViewAllLink',
  attributes: {
    sectionId
  }
});
export const onMultiSiteAdvancedSearchSelected = ({
  trigger,
  actionSubjectId,
  isLoading,
  newTab,
  destinationId,
  index
}) => {
  return {
    action: 'selected',
    actionSubject: 'advancedSearchLink',
    actionSubjectId,
    source: BASE_ANALYTICS_SOURCE,
    eventType: 'ui',
    attributes: {
      trigger,
      isLoading,
      newTab,
      destinationId,
      index
    }
  };
};
export const onMoreFiltersSelected = ({
  trigger,
  selectedFiltersCount
}) => {
  return {
    action: 'selected',
    actionSubject: 'moreFilterLink',
    source: BASE_ANALYTICS_SOURCE,
    eventType: 'ui',
    attributes: {
      trigger,
      selectedFiltersCount
    }
  };
};
export const onSearchResultSelected = ({
  screen,
  actionSubject
}) => {
  return {
    action: 'selected',
    actionSubject: actionSubject,
    actionSubjectId: screen,
    source: BASE_ANALYTICS_SOURCE,
    eventType: 'track',
    attributes: {}
  };
};
export const onSearchResultHighlighted = ({
  screen,
  actionSubject
}) => {
  return {
    action: 'highlighted',
    actionSubject: actionSubject,
    actionSubjectId: screen,
    source: BASE_ANALYTICS_SOURCE,
    eventType: 'ui',
    attributes: {}
  };
};
export const onSearchResultContext = ({
  screen,
  actionSubject
}) => {
  return {
    action: 'contextMenu opened',
    actionSubject: actionSubject,
    actionSubjectId: screen,
    source: BASE_ANALYTICS_SOURCE,
    eventType: 'ui',
    attributes: {}
  };
};
export let ResultsShownActionSubjectId = /*#__PURE__*/function (ResultsShownActionSubjectId) {
  ResultsShownActionSubjectId["PREQUERY"] = "preQuerySearchResults";
  ResultsShownActionSubjectId["POSTQUERY"] = "postQuerySearchResults";
  ResultsShownActionSubjectId["CACHED"] = "cachedResults";
  return ResultsShownActionSubjectId;
}({});
export const onSearchResultsShown = ({
  actionSubjectId,
  resultCount,
  sectionCount,
  results,
  timeToQueryMs,
  activeProduct,
  isMultiProduct,
  filters
}) => {
  return {
    action: 'shown',
    actionSubject: 'searchResults',
    actionSubjectId,
    source: BASE_ANALYTICS_SOURCE,
    eventType: 'ui',
    attributes: {
      resultCount,
      sectionCount,
      timeToQueryMs,
      results,
      noResultsFetched: !resultCount,
      activeProduct,
      isMultiProduct,
      filters
    }
  };
};
export const onTextEntered = () => {
  return {
    action: 'entered',
    actionSubject: 'text',
    actionSubjectId: 'searchDialogTextField',
    source: BASE_ANALYTICS_SOURCE,
    eventType: 'track',
    attributes: {}
  };
};
export const onShowMoreClicked = ({
  total,
  currentSize,
  pageSize
}) => {
  return {
    action: 'clicked',
    actionSubject: 'button',
    actionSubjectId: 'showMoreButton',
    source: BASE_ANALYTICS_SOURCE,
    eventType: 'ui',
    attributes: {
      total,
      currentSize,
      pageSize
    }
  };
};
export const onShowAllClicked = ({
  total,
  currentSize,
  pageSize
}) => {
  return {
    action: 'clicked',
    actionSubject: 'button',
    actionSubjectId: 'showAllLink',
    source: BASE_ANALYTICS_SOURCE,
    eventType: 'ui',
    attributes: {
      total,
      currentSize,
      pageSize
    }
  };
};
export const onPreQueryScreenViewed = ({
  searchSessionId,
  trigger
}) => {
  return {
    name: 'searchDialogPreQueryScreen',
    eventType: 'screen',
    attributes: {
      searchSessionId,
      trigger
    }
  };
};
/**
 * We allow onRequestMade to be given an explicit context because it gets fired at the same level as the query contexts so it won't normally pick it up
 */
export const onRequestMade = ({
  actionSubjectId,
  timings,
  activeProduct,
  isExpanded,
  isMultiProduct,
  filters
}, additionalContext = {}, nonPrivacySafeAttributes = {
  query: ''
}) => {
  return {
    action: 'completed',
    actionSubject: 'searchRequest',
    actionSubjectId,
    source: BASE_ANALYTICS_SOURCE,
    eventType: 'track',
    attributes: {
      activeProduct,
      isExpanded,
      isMultiProduct,
      filters,
      ...timings,
      ...additionalContext
    },
    nonPrivacySafeAttributes
  };
};
export const onPreQueryEmpty = () => ({
  action: 'shown',
  eventType: 'ui',
  actionSubject: 'searchResults',
  actionSubjectId: 'preQuerySearchResults',
  attributes: {
    resultCount: 0,
    results: []
  },
  source: BASE_ANALYTICS_SOURCE
});
export const onDismissed = () => {
  return {
    action: 'dismissed',
    actionSubject: 'searchDialog',
    source: BASE_ANALYTICS_SOURCE,
    eventType: 'ui'
  };
};
export const onShown = ({
  visibleProducts,
  visibleTabsCount
}) => {
  return {
    action: 'shown',
    actionSubject: 'searchDialog',
    source: BASE_ANALYTICS_SOURCE,
    eventType: 'ui',
    attributes: {
      visibleProducts,
      visibleTabsCount
    }
  };
};
export const onDropdownMenuFilterView = ({
  filterType
}) => {
  return {
    action: 'viewed',
    actionSubject: 'filterField',
    actionSubjectId: 'dropdownMenuFilterField',
    source: BASE_ANALYTICS_SOURCE,
    eventType: 'ui',
    attributes: {
      filterType
    }
  };
};
export const onFilterSelect = ({
  filterId,
  filterType,
  filterSource
}) => {
  return {
    action: 'selected',
    actionSubject: 'filter',
    actionSubjectId: 'searchDialogFilter',
    source: BASE_ANALYTICS_SOURCE,
    eventType: 'ui',
    attributes: {
      filterId,
      filterType,
      filterSource
    }
  };
};
export const onFilterUnselect = ({
  filterId,
  filterType,
  filterSource
}) => {
  return {
    action: 'unselected',
    actionSubject: 'filter',
    actionSubjectId: 'searchDialogFilter',
    source: BASE_ANALYTICS_SOURCE,
    eventType: 'ui',
    attributes: {
      filterId,
      filterType,
      filterSource
    }
  };
};
export const onFilterFieldCleared = ({
  filterType
}) => {
  return {
    action: 'cleared',
    actionSubject: 'filterField',
    actionSubjectId: 'searchDialogFilterField',
    source: BASE_ANALYTICS_SOURCE,
    eventType: 'ui',
    attributes: {
      filterType
    }
  };
};
export const onFiltersCleared = () => {
  return {
    action: 'clicked',
    actionSubject: 'button',
    actionSubjectId: 'searchDialogClearFilters',
    source: BASE_ANALYTICS_SOURCE,
    eventType: 'ui',
    attributes: {}
  };
};
export const onPaneLoadComplete = (product, duration) => {
  return {
    action: 'loadComplete',
    actionSubject: 'searchDialogPane',
    actionSubjectId: product,
    source: BASE_ANALYTICS_SOURCE,
    eventType: 'track',
    attributes: {
      durationMs: duration
    }
  };
};
export const onExperimentLoaded = (abTest, experimentRequestDuration, isMultiProduct) => {
  return {
    action: 'loaded',
    actionSubject: 'experiment',
    source: BASE_ANALYTICS_SOURCE,
    eventType: 'operational',
    attributes: {
      abTest,
      experimentRequestDuration,
      isMultiProduct
    }
  };
};
export const onTabSelected = ({
  tabName
}, additionalContext = {}, nonPrivacySafeAttributes = {
  query: ''
}) => {
  // this event is fired at the same level as the anlytics context hence it needs mandatory additional objects.
  return {
    action: 'clicked',
    actionSubject: 'tab',
    actionSubjectId: 'crossProductSearchTab',
    source: BASE_ANALYTICS_SOURCE,
    eventType: 'ui',
    attributes: {
      tabName,
      ...additionalContext
    },
    nonPrivacySafeAttributes
  };
};
export const onThirdPartyAuthorisedCheck = (authorised, product) => {
  return {
    action: 'checked',
    actionSubject: 'thirdPartyAuth',
    actionSubjectId: product,
    source: BASE_ANALYTICS_SOURCE,
    eventType: 'track',
    attributes: {
      authorised
    }
  };
};
export const onThirdPartyAuthorised = product => {
  return {
    action: 'authorised',
    actionSubject: 'thirdPartyProduct',
    actionSubjectId: product,
    source: BASE_ANALYTICS_SOURCE,
    eventType: 'track',
    attributes: {}
  };
};

// Smart User Picker analytics
// These analytics will be used to join with the backend collaboration graph analytics to identify
// if our model is performing well.

const createEvent = (eventType, action, actionSubject, attributes = {}) => ({
  eventType,
  action,
  actionSubject,
  attributes: {
    ...attributes
  }
});
const position = (options, value) => {
  return value ? options.findIndex(option => option.id === value.data.id) : -1;
};
const result = option => {
  return option ? optionData2Analytics(option.data) : null;
};
const optionData2Analytics = option => {
  const {
    id,
    type
  } = option;
  return {
    id: id ? id : null,
    type: type || null
  };
};
const createDefaultPickerAttributes = (fieldId, collabGraphSessionId) => ({
  context: fieldId,
  isCheckbox: true,
  queryLength: 0,
  collabGraphSessionId
});
export const selectEvent = (value, options, fieldId, collabGraphSessionId) => {
  return createEvent('ui', 'clicked', 'userPicker', {
    ...createDefaultPickerAttributes(fieldId, collabGraphSessionId),
    position: position(options, value),
    result: result(value)
  });
};
export const onRecentSearchSelected = () => {
  return {
    action: 'clicked',
    actionSubject: 'button',
    actionSubjectId: 'recentSearch',
    source: BASE_ANALYTICS_SOURCE,
    eventType: 'ui',
    attributes: {}
  };
};

// The following are used to track engagement with onboarding components for SAIN (smart answers) in Confluence quick search

export const onPrequeryBannerShown = () => {
  return {
    action: 'shown',
    actionSubject: 'aiOnboardingPrompt',
    actionSubjectId: 'prequeryBanner',
    source: BASE_ANALYTICS_SOURCE,
    eventType: 'ui',
    attributes: {}
  };
};
export const onSuggestedPromptClick = promptId => {
  return {
    action: 'clicked',
    actionSubject: 'aiOnboardingPrompt',
    actionSubjectId: promptId,
    source: BASE_ANALYTICS_SOURCE,
    eventType: 'ui',
    attributes: {}
  };
};
export const onPrequeryBannerDismiss = () => {
  return {
    action: 'clicked',
    actionSubject: 'aiOnboardingPrompt',
    actionSubjectId: 'dismissButton',
    source: BASE_ANALYTICS_SOURCE,
    eventType: 'ui',
    attributes: {}
  };
};